<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="code-input" subscriptSizing="dynamic">
    <mat-label>{{ 'two_fa.verificationCode' | translate }}</mat-label>
    <input matInput [(ngModel)]="code" name="verificationCode" maxlength="6" placeholder="123456"
      (keyup.enter)="submit()" [disabled]="isSubmitting">
  </mat-form-field>

  @if (!!errorMessage) {
    <div class="mat-caption error">
      {{ errorMessage }}
    </div>
  }

  <div class="resend-container">
    <button mat-button (click)="resendSms()" [disabled]="!canResend || isSubmitting">
      {{ 'two_fa.sms_confirmation.resend' | translate }}
      @if (!canResend) {
        <span>({{ countdownFormatted }})</span>
      }
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()" [disabled]="isSubmitting">
    {{ 'cancel' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!isValidCode() || isSubmitting">
    {{ 'confirm' | translate }}
  </button>
</mat-dialog-actions>